import { Component, Listen, Prop, State, h } from '@stencil/core';
import type { ConversationalSearchProductHierarchy } from '../../../conversational-search-types/conversational-search-types.type';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';
import { ConversationalSearchDeatilsHeader } from '../../../conversational-search-partials/details-header/details-header';
import { ConversationalSearchProductHierarchySuggestions } from './product-hierarchy-suggestions';
import { isMobile } from '../../../../../../utils/media';

@Component({
  tag: 'uiaas-search-conversational-search-messages-product-hierarchy',
  styleUrl: 'product-hierarchy.scss',
  shadow: false,
})
export class ConversationalSearchMessagesProductHierarchy {
  @Prop() readonly labelProvider: labelProviderInterface;
  @Prop() readonly parentData: ConversationalSearchProductHierarchy;
  @Prop() readonly childrenData: ConversationalSearchProductHierarchy['subLevels'];
  @Prop() readonly query: string;
  @Prop() readonly isDifferentCategory?: boolean;
  @Prop() readonly isParentData?: boolean;
  @Prop() readonly language: string;

  @State() isMobileView = isMobile();

  @Listen('resize', { target: 'window' })
  @Listen('load', { target: 'window' })
  handleResize() {
      this.isMobileView = isMobile();
  }

  private renderCarousel = (subLevels: ConversationalSearchProductHierarchy['subLevels']) => (
    <uiaas-search-conversational-search-messages-product-hierarchy-carousel
      data={subLevels}
      labelProvider={(e, f) => this.labelProvider(e, f)}
      query={this.query}
      language={this.language}
    />
  );

  private renderItems = (subLevels: ConversationalSearchProductHierarchy['subLevels']) => (
    <ConversationalSearchProductHierarchySuggestions
      data={subLevels}
      labelProvider={(e, f) => this.labelProvider(e, f)}
      query={this.query}
      optionsAmount={subLevels?.length}
      language={this.language}
    />
  );

  private renderCorrectView = (childrenData) => {
      const isSingleOption = childrenData?.length === 1 && !this.isMobileView && !this.isDifferentCategory;
      const isCarouselVariant = childrenData?.length > 2 || this.isMobileView;

      return isSingleOption || !isCarouselVariant
        ? this.renderItems(childrenData)
        : this.renderCarousel(childrenData);
  };

  render() {
      return (
        <div class='conversational-search-messages-product-hierarchy'>
          <section class="conversational-search-messages-product-hierarchy__header">
            <ConversationalSearchDeatilsHeader
              title={this.parentData?.title}
              url={this.parentData?.openUrl}
              category={this.parentData?.categoryL2}
              categoryLocalized={this.parentData?.categoryL2Translation}
              isParentData={this.isParentData}
              query={this.query}
              size="large"
              tag="h2"
            />
          </section>
          <div class="conversational-search-messages-product-hierarchy-content">
            <div class="conversational-search-messages-product-hierarchy-content__summary">
              <uiaas-search-conversational-search-expandable-text
                text={this.parentData?.summary}
                query={this.query}
                labelProvider={(e, f) => this.labelProvider(e, f)}
              />
            </div>
            <div class="conversational-search-messages-product-hierarchy-content__results">
              {this.renderCorrectView(this.childrenData)}
            </div>
          </div>
        </div>
      );
  }
}
